<template>
  <div style="height: 100vh; width: 100%">
    <GmapMap
      :center="currentCenter"
      :zoom="currentZoom"
      map-type-id="roadmap"
      style="width: 100%; height: 100%"
      :options="googlemap_options"
      ref="mapRef"
      @center_changed="centerUpdate"
    >
      <gmap-info-window
        :options="infoOptions"
        :position="infoWindowPos"
        :opened="infoWinOpen"
        @closeclick="infoWinOpen = false"
      >
        <el-card :body-style="{ padding: '0px' }">
          <div slot="header" class="clearfix">
            <span class="info-header">{{ infoWindowHeader }}</span>
          </div>
          <el-carousel indicator-position="outside">
            <el-carousel-item
              v-for="(xhsImage, index) in carouselItems"
              :key="index"
            >
              <img
                :src="
                  xhsImage.replace(
                    'http://sns-webpic-qc.xhscdn.com/',
                    'img/xhs/'
                  )
                "
                class="image"
              />
            </el-carousel-item>
          </el-carousel>
          <div style="padding: 14px;">
            <pre>{{ infoWindowText }}</pre>
            <div class="bottom clearfix">
              <el-button
                type="text"
                class="button"
                @click="gotoXhs(infoWindowLink)"
                >去小红书</el-button
              >
            </div>
          </div>
        </el-card>
      </gmap-info-window>
      <template v-for="(m, index) in markers">
        <GmapMarker
          :key="index"
          :place="m.place"
          :position="m.position"
          :clickable="true"
          :draggable="false"
          @click="toggleInfoWindow(m, index)"
          :title="m.name"
          :icon="m.icon"
          v-if="arrayMarkerType.indexOf(m.type) >= 0"
        />
      </template>
    </GmapMap>
    <div class="div-float-left">
      <el-switch
        v-model="isMarkerOnPlace"
        active-text="游玩地点"
        active-color="rgb(251,98,85)"
      >
      </el-switch>
      <el-switch
        v-model="isMarkerOnFood"
        active-text="食物地点"
        active-color="rgb(252,243,86)"
      >
      </el-switch>
      <el-switch
        v-model="isMarkerOnDaka"
        active-text="打卡地点"
        active-color="rgb(103,142,255)"
      >
      </el-switch>
    </div>
    <el-button
      v-show="isTripButtonVisible"
      type="primary"
      icon="el-icon-document"
      circle
      class="btn-float btn-show-drawer"
      @click="showDrawer"
    ></el-button>
    <el-drawer
      title="行程"
      :visible.sync="drawer"
      direction="btt"
      :show-close="false"
      size="90%"
      @closed="onDrawerClosed"
    >
      <el-menu
        :default-active="menuActiveIndex"
        class="el-menu-demo"
        mode="horizontal"
        @select="handleChangeTripBy"
      >
        <el-menu-item index="1">按地点</el-menu-item>
        <el-menu-item index="2">按时间(10/25)</el-menu-item>
        <el-menu-item index="3">按时间(10/26)</el-menu-item>
        <el-menu-item index="4">按时间(10/27)</el-menu-item>
      </el-menu>
      <div class="tripWrapper">
        <div v-if="menuActiveIndex == 1" class="m-trip_by_place">
          <trip-place
            v-for="(place, index) in places"
            :key="place.name"
            :place="place"
            :idx="index"
            @toggleInfoWindow="toggleInfoWindow"
          ></trip-place>
        </div>
        <div v-if="menuActiveIndex >= 2" class="m-trip_by_date">
          <el-timeline>
            <el-timeline-item
              v-for="timelinePlace in timelinePlaces"
              :key="timelinePlace.time"
              :timestamp="timelinePlace.time"
              placement="top"
            >
              <el-card>
                <div slot="header" class="clearfix">
                  <span>{{ timelinePlace.place }}</span>
                  <el-button
                    style="float: right; padding: 3px 0"
                    type="text"
                    @click="showOnMap(timelinePlace.place)"
                    >在地图上显示</el-button
                  >
                </div>
                <p class="text-blue">游玩时间：{{ timelinePlace.duration }}</p>
                <p>{{ timelinePlace.comments }}</p>
                <p class="text-muted">{{ timelinePlace.transportation }}</p>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { latLng } from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup, LTooltip } from "vue2-leaflet";
import { gmapApi } from "vue2-google-maps";
import TripPlace from "../components/TripPlace.vue";
import { places, schedule } from "../assets/guide/aomen.json";

// let allImg = []
// places.forEach((place) => {
//     allImg.push(place.xhs.image_list.join('\n'))
// })
let ttt = [];
let filteredPlace = places
  .filter((place) => {
    if (place.type === "place" && place.isActive !== false) {
      ttt.push(place.name);
    }
    return place.isActive !== false;
  })
  .map((place) => {
    let tmpPlace = place;
    let iconList = {
      place: "http://maps.google.com/mapfiles/kml/paddle/red-circle.png",
      daka: "http://maps.google.com/mapfiles/kml/paddle/blu-circle.png",
      food: "http://maps.google.com/mapfiles/kml/paddle/ylw-circle.png"
    };
    tmpPlace.icon = {
      url: iconList[place.type],
      scaledSize: { width: 40, height: 40 }
    };
    return tmpPlace;
  });
console.log(ttt.join(","));
// console.log(allImg.join('\n'))
export default {
  name: "Example",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LTooltip,
    TripPlace
  },
  data() {
    return {
      places: places,
      zoom: 6,
      center: latLng(22.16440204143302, 113.55518044059058),
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      withPopup: latLng(35.66634784801858, 139.75972976237588),
      withTooltip: latLng(35.66634784801858, 139.75972976237588),
      currentZoom: 13.3,
      currentCenter: latLng(22.16440204143302, 113.55518044059058),
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.2
      },
      markers: [],
      showMap: true,
      googlemap_options: {
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: true,
        disableDefaultUI: true,
        clickableIcons: false,
        gestureHandling: "cooperative",
        backgroundColor: "white"
      },
      infoWindowHeader: "",
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,

      infoOptions: {
        //optional: offset infowindow so it visually sits nicely on top of our marker
        pixelOffset: {
          width: 0,
          height: -40
        }
      },
      infoWindowText: "",
      carouselItems: [],
      infoWindowLink: "",
      drawer: false,
      isTripButtonVisible: true,
      menuActiveIndex: "1",
      transitDirection: {
        start: "",
        end: ""
      },
      drivingDirection: {
        start: "",
        end: ""
      },
      startPoint: "",
      endPoint: "",
      timelinePlaces: [],
      isMarkerOnPlace: true,
      isMarkerOnFood: true,
      isMarkerOnDaka: true,
    };
  },
  computed: {
    google: gmapApi,
    arrayMarkerType: function() {
      let tmpType = []
      if (this.isMarkerOnPlace) {
        tmpType.push("place")
      }
      if (this.isMarkerOnFood) {
        tmpType.push("food")
      }
      if (this.isMarkerOnDaka) {
        tmpType.push("daka")
      }
      console.log(tmpType)
      return tmpType
    }
  },
  methods: {
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
      console.log(this.google.maps.places.PlacesServiceStatus);
    },
    centerUpdate(center) {
      //console.log(center.lat(), center.lng());
    },
    showLongText() {
      this.showParagraph = !this.showParagraph;
    },
    innerClick() {
      alert("Click!");
    },
    toggleInfoWindow: function(marker, idx) {
      this.drawer = false;
      this.$refs.mapRef.$mapPromise.then((map) => {
        map.panTo(marker.position);
        this.smoothZoom(map, 19, this.currentZoom, {
          lat: marker.position.lat + 0.0006,
          lng: marker.position.lng
        });
      });
      this.infoWindowHeader = marker.name;
      this.infoWindowPos = marker.position;
      // this.infoOptions.content = `<p class="tag-store-name">${marker.storeName}<span class="tag">${marker.storeType}</span></p>`;
      this.carouselItems = marker.xhs.image_list;
      this.infoWindowText = marker.xhs.desc;
      this.infoWindowLink = marker.link;
      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },
    showOnMap(name) {
      let thisPlace = null;
      let index = 0
      for (index = 0; index < this.markers.length; index++) {
        const place = this.markers[index];
        if (place.name === name) {
          thisPlace = place;
          break
        }
      }
      if (thisPlace) {
        console.log(index)
        this.drawer = false
        this.toggleInfoWindow(thisPlace, index)
      }
    },
    gotoXhs(link) {
      window.open(link);
    },
    // the smooth zoom function
    smoothZoom(map, max, cnt, toPosition) {
      if (cnt >= max) {
        this.currentZoom = 19;
        this.currentCenter = toPosition;
        return;
      } else {
        let that = this;
        this.$refs.mapRef.$mapPromise.then((map) => {
          var z = this.google.maps.event.addListener(
            map,
            "zoom_changed",
            function(event) {
              that.google.maps.event.removeListener(z);
              that.smoothZoom(map, max, cnt + 1, toPosition);
            }
          );
          setTimeout(function() {
            map.setZoom(cnt);
          }, 70); // 80ms is what I found to work well on my system -- it might not work well on all systems
        });
      }
    },
    showDrawer() {
      this.isTripButtonVisible = false;
      this.drawer = true;
    },
    onDrawerClosed() {
      this.isTripButtonVisible = true;
    },
    handleChangeTripBy(index) {
      this.menuActiveIndex = index;
      console.log(index);
      if (index === "2") {
        this.timelinePlaces = schedule["10/25"];
        console.log(schedule["10/05"]);
      } else if (index === "3") {
        this.timelinePlaces = schedule["10/26"];
      } else if (index === "4") {
        this.timelinePlaces = schedule["10/27"];
      }
    },
    selectLocation(type, location) {
      if (type === "start") {
        this.startPoint = location;
      }
      if (type === "end") {
        this.endPoint = location;
      }
      this.placeDialogVisible = false;
    },
    async getPlaceDetails(placeId) {
      // Use place ID to create a new Place instance.
      let Place = this.google.maps.places.Place;
      const place = new Place({
        id: placeId,
        requestedLanguage: "en" // optional
      });

      // Call fetchFields, passing the desired data fields.
      await place.fetchFields({
        fields: ["displayName", "formattedAddress", "location"]
      });
      // Log the result
      console.log(place.displayName);
      console.log(place.formattedAddress);

      // Add an Advanced Marker
      this.markers.push({
        position: place.location,
        title: place.displayName
      });
    }
  },
  mounted() {
    this.markers = filteredPlace.map((place) => {
      place.position = {
        lat: place.position[0],
        lng: place.position[1]
      };
      place.location = [place.position[1], place.position[0]];
      place.mapType = "google";
      return place;
    });
  }
};
</script>
<style scoped>
>>> .tag {
  border: 5px solid transparent;
  color: lightcoral;
  margin-left: 10px;
  background-color: lightgray;
  border-radius: 5px;
}
>>> .tag-store-name {
  font-size: 1.1em;
  font-weight: 600;
}

.time {
  font-size: 13px;
  color: #999;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.button {
  padding: 0;
  float: right;
}

.image {
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;
  display: block;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

.el-carousel {
  width: 400px;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.info-header {
  font-size: 1.5em;
  font-weight: bold;
}
pre {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5; /* Change this number to limit lines */
  line-clamp: 5; /* For modern browsers */
  white-space: pre-wrap; /* Ensures preformatted text wraps */
}
.btn-show-drawer {
  position: fixed;
  right: 30px;
  bottom: 20px;
  z-index: 10;
}
.btn-show-transit_direction {
  position: fixed;
  right: 30px;
  top: 20px;
  z-index: 10;
}
.btn-show-driving_direction {
  position: fixed;
  right: 160px;
  top: 20px;
  z-index: 10;
}
.btn-show-baidu_direction {
  position: fixed;
  right: 290px;
  top: 20px;
  z-index: 10;
}
>>> .el-drawer__body {
  height: 100%;
}
.tripWrapper {
  margin-top: 20px;
  overflow: scroll;
  padding-bottom: 200px;
  height: 100%;
  text-align: left;
}
div:has(table > tbody > tr.tranroute-plan-list) {
  position: fixed;
  bottom: 0;
}
.el-card {
  margin-right: 30px;
}
.text-blue {
  color: #409eff;
}
.text-muted {
  font-size: 0.9em;
  color: gray;
}

.div-float-left {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 120px;
  height: 80px;
  background: white;
  padding: 10px;
}
.el-switch {
  margin-bottom: 10px;
}
</style>
